<template><div><h1 id="compiling-your-own-firmware" tabindex="-1"><a class="header-anchor" href="#compiling-your-own-firmware"><span>Compiling Your Own Firmware</span></a></h1>
<div class="hint-container caution">
<p class="hint-container-title">Caution</p>
<p>Building and flashing your own firmware has the potential to brick your device. Do not do this unless you are sure you know what you're doing <strong>and have a way to recover from a bad flash</strong>. Some level of knowledge with using the Linux command line is required.</p>
</div>
<ol>
<li>
<p><strong>Install tools and libraries needed for coreboot/edk2:</strong></p>
<ul>
<li>Debian/Ubuntu based distros: <code v-pre>sudo apt install -y bison build-essential curl flex git gnat imagemagick libncurses5-dev m4 nasm python-is-python3 uuid-dev zlib1g-dev libssl-dev pkg-config libcmocka-dev libnss3-dev</code></li>
<li>Arch based distros: <code v-pre>sudo pacman --needed -S base-devel curl git gcc-ada ncurses zlib nasm imagemagick pkgconf cmocka nss</code></li>
<li>Redhat based distros: <code v-pre>sudo dnf install git make gcc-gnat flex bison xz bzip2 gcc g++ ncurses-devel wget zlib-devel patch openssl libuuid-devel nasm texinfo pkgconfig cmocka-devel nss-devel</code></li>
</ul>
</li>
<li>
<p><strong>Clone the repository:</strong></p>
<ul>
<li><code v-pre>git clone https://github.com/mrchromebox/coreboot.git</code></li>
</ul>
</li>
<li>
<p><strong>(Optional) Checkout a specific branch:</strong></p>
<ul>
<li><code v-pre>cd coreboot</code></li>
<li><code v-pre>git checkout &lt;branch-name&gt;</code>
<ul>
<li>For example, <code v-pre>git checkout MrChromebox-2509</code> or <code v-pre>git checkout MrChromebox-2512</code></li>
</ul>
</li>
</ul>
</li>
<li>
<p><strong>Clone the submodules:</strong></p>
<ul>
<li><code v-pre>cd coreboot</code> (if not already in the directory)</li>
<li><code v-pre>git submodule update --init --checkout --recursive</code></li>
</ul>
</li>
<li>
<p><strong>Build the coreboot toolchain</strong></p>
<ul>
<li><code v-pre>make crossgcc-i386 CPUS=$(nproc)</code></li>
</ul>
</li>
<li>
<p><strong>Make changes now, if needed.</strong></p>
<ul>
<li>Common changes include:
<ul>
<li>Replacing the default logo (<code v-pre>Documentation/coreboot_logo.bmp</code>)</li>
<li>Enabling serial debug output (<code v-pre>CONFIG_CONSOLE_SERIAL=y</code>)</li>
</ul>
</li>
</ul>
</li>
<li>
<p><strong>Build the firmware</strong></p>
<ul>
<li><code v-pre>./build-uefi.sh &lt;boardname&gt;</code>
<ul>
<li>For example, <code v-pre>./build-uefi.sh panther</code></li>
<li>If successful, the compiled image will be found in <code v-pre>~/dev/roms</code></li>
</ul>
</li>
</ul>
</li>
<li>
<p><strong>See <RouteLink to="/docs/firmware/manual-flashing.html">Flashing Manually</RouteLink> to flash</strong></p>
</li>
</ol>
<h2 id="related-documentation" tabindex="-1"><a class="header-anchor" href="#related-documentation"><span>Related Documentation</span></a></h2>
<ul>
<li><strong><RouteLink to="/docs/firmware/manual-flashing.html">Manual Flashing</RouteLink></strong> - How to flash your custom firmware</li>
<li><strong><a href="https://github.com/MrChromebox/coreboot" target="_blank" rel="noopener noreferrer">MrChromebox coreboot Repository</a></strong> - Firmware source code</li>
<li><strong><a href="https://github.com/MrChromebox/edk2" target="_blank" rel="noopener noreferrer">MrChromebox edk2 Repository</a></strong> - UEFI payload source</li>
<li><strong><a href="https://doc.coreboot.org/" target="_blank" rel="noopener noreferrer">coreboot Documentation</a></strong> - Upstream coreboot documentation</li>
<li><strong><RouteLink to="/docs/contributing.html">Contributing</RouteLink></strong> - How to contribute firmware improvements</li>
<li><strong><RouteLink to="/docs/support/unbricking/">Unbricking</RouteLink></strong> - Recovery from bad flash</li>
</ul>
</div></template>
<script>
export const _pageData = JSON.parse("{\"path\":\"/docs/support/compiling.html\",\"title\":\"Compiling Your Own Firmware\",\"lang\":\"en-US\",\"frontmatter\":{},\"git\":{\"updatedTime\":1767635925000,\"contributors\":[{\"name\":\"Matt DeVillier\",\"username\":\"\",\"email\":\"matt.devillier@gmail.com\",\"commits\":5}],\"changelog\":[{\"hash\":\"b95820ae3455b1842385707df703a5a4cd9402b1\",\"time\":1767635925000,\"email\":\"matt.devillier@gmail.com\",\"author\":\"Matt DeVillier\",\"message\":\"docs: Add optional step to checkout specific branch before updating submodules\"},{\"hash\":\"69c5bdfebc70ff0be61b3ce5a85dfb8b47e55645\",\"time\":1767020997000,\"email\":\"matt.devillier@gmail.com\",\"author\":\"Matt DeVillier\",\"message\":\"compiling: Update dependencies\"},{\"hash\":\"8d8a83e2cc976c0bca131e627534b1217fdce80e\",\"time\":1764109375000,\"email\":\"matt.devillier@gmail.com\",\"author\":\"Matt DeVillier\",\"message\":\"docs: add related documentation sections for consistency\"},{\"hash\":\"e6546f72a11fbc003637c52beb1b6d74a8513c73\",\"time\":1720984010000,\"email\":\"matt.devillier@gmail.com\",\"author\":\"Matt DeVillier\",\"message\":\"compiling.md: add 'recursive' option to submodule checkout\"},{\"hash\":\"39a8e8685b2be911b99ae30f8f0c7fb6234b5e50\",\"time\":1719969991000,\"email\":\"matt.devillier@gmail.com\",\"author\":\"Matt DeVillier\",\"message\":\"WIP content update\"}]},\"filePathRelative\":\"docs/support/compiling.md\"}")
export default { name: "compiling.md" }
</script>